import { ComponentChildren, FunctionalComponent, h } from 'preact';
import { Fragment as div } from 'preact/compat';
import { useState } from 'preact/hooks';
import { v4 as uuidv4 } from 'uuid';
import { Reveal } from '../../util-components/Reveal';

import { ServiceCardButton } from './ServiceCardButton';
import { ServiceCardLinkMobile, LinkProps } from './ServiceCardLinkMobile';

export interface UnparsedServiceCardMobile {
	headline: string;
	linkMore?: string;
	highlighted: string;
	children: ComponentChildren;
}
export interface ParsedServiceCardMobile {
	headline: {
		label: string;
	};
	linkMore: LinkProps;
	highlighted: boolean;
}

const parseProps = (unparsedProps: UnparsedServiceCardMobile): ParsedServiceCardMobile => {
	const parsedProps: ParsedServiceCardMobile = {
		headline: JSON.parse(unparsedProps.headline),
		linkMore: unparsedProps.linkMore ? JSON.parse(unparsedProps.linkMore) : null,
		highlighted: JSON.parse(unparsedProps.highlighted),
	};
	return parsedProps;
};

export const ServiceCardMobile: FunctionalComponent<UnparsedServiceCardMobile> = (unparsedProps) => {
	const uuid = uuidv4();
	const props = parseProps(unparsedProps);
	const { headline, linkMore, highlighted } = props;
	const [expanded, setExpanded] = useState(false);
	const handleButtonToggle = () => {
		if (expanded) {
			setExpanded(false);
		} else {
			setExpanded(true);
		}
	};

	return (
		<div className="SP-ServiceCard__mobile">
			<ServiceCardButton {...headline} expanded={expanded} id={uuid} toggle={handleButtonToggle} />
			<Reveal in={expanded} duration={300} className="SP-CardList__collapsible" id={uuid}>
				{unparsedProps.children}
				{linkMore && <ServiceCardLinkMobile {...linkMore} highlighted={highlighted} />}
			</Reveal>
		</div>
	);
};
